import React from 'react';
import * as CarbonIcons from '@carbon/react/icons';
import { AsperaError } from '../../classes/AsperaError';
/**
 * Render icons for use on the page from Carbon Library.
 *
 * @param name - name of the icon (usually `WarningItem` or something with that pattern)
 * @param size - size to render. Default is 16
 * @param extraProps - extra props for the component
 *
 * @returns - ReactNode to render the Icon on screen
 */
export const getIcon = (name, size = 16, extraProps) => {
    const icon = CarbonIcons[`${name}`];
    const props = extraProps || {};
    props.size = size;
    if (icon) {
        return React.createElement(icon, props);
    }
    else {
        new AsperaError('getIcon: unable to find requested icon', { name, icon });
        try {
            return React.createElement(CarbonIcons.WarningSquareFilled, props);
        }
        catch (error) {
            new AsperaError('getIcon: unable to find backup icon', { name, icon, error });
            return null;
        }
    }
};
/**
 * Get icon that can be passed to renderIcon or similar systems.
 *
 * @param name - name of the icon (usually `WarningItem` or something with that pattern)
 * @param size - size to render. Default is 16
 * @param extraProps - extra props for the component
 *
 * @returns - React Functional component that can be passed to renderIcon or other similar systems
 */
export const getIconComponent = (name, size = 16, extraProps) => {
    const icon = CarbonIcons[`${name}`];
    const props = extraProps || {};
    props.size = size;
    if (icon) {
        const IconComponent = (topProps) => React.createElement(icon, Object.assign({}, topProps || {}, props));
        return IconComponent;
    }
    else {
        new AsperaError('getIconComponent: unable to find requested icon', { name, icon });
        try {
            const IconComponent = (topProps) => React.createElement(CarbonIcons.WarningSquareFilled, Object.assign({}, topProps || {}, props));
            return IconComponent;
        }
        catch (error) {
            new AsperaError('getIconComponent: unable to find backup icon', { name, icon, error });
            const IconComponent = () => null;
            return IconComponent;
        }
    }
};
